export default __webpack_public_path__ + "static/media/webp.37961621.png";